import { Injectable } from '@angular/core';
import { CheckoutConnector } from '@spartacus/checkout/base/core';
import { Address } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { CustomPayPalPayment, CustomRedsysPayment } from '../models/custom-checkout.model';
import { CustomCheckoutAdapter } from './custom-checkout.adapter';

@Injectable({
  providedIn: 'root',
})
export class CustomCheckoutConnector extends CheckoutConnector {
  constructor(
    protected adapter: CustomCheckoutAdapter
  ) {
    super(adapter);
  }

  public loadRedsysPayment(
    userId: string,
    cartId: string,
    saveCard: boolean
  ): Observable<CustomRedsysPayment> {
    return this.adapter.loadRedsysPayment(userId, cartId, saveCard);
  }

  update(userId: string, addressId: string, address: Address): Observable<{}> {
    return this.adapter.update(userId, addressId, address);
  }

  public loadSequraPayment(
    userId: string,
    cartId: string,
    paymentId: string
  ): Observable<any> {
    return this.adapter.loadSequraPayment(userId, cartId, paymentId);
  }


  public loadPaypalPayment(
    userId: string,
    cartId: string,
    paymentId: string
  ): Observable<CustomPayPalPayment> {
    return this.adapter.loadPaypalPayment(userId, cartId, paymentId);
  }

  public createPaypalOrder(
    userId: string,
    cartId: string,
    paymentId: string,
    token: string,
    PayerID: string
  ): Observable<Order> {
    return this.adapter.createPaypalOrder(userId, cartId, paymentId, token, PayerID);
  }


  public simulateOrder(
    userId: string,
    cartId: string,
  ): Observable<any> {
    return this.adapter.simulateOrder(userId, cartId);
  }

  public validateCart(
    userId: string,
    cartId: string,
  ): Observable<any> {
    return this.adapter.validateCart(userId, cartId);
  }

  public unavailableProducts(
    userId: string,
    cartId: string,
  ): Observable<any> {
    return this.adapter.unavailableProducts(userId, cartId);
  }
}
